module.exports = __webpack_public_path__ + "static/ULaval-bf34a8fba57551b86ec0dd7b9888089a.svg";